export default [
    {
        "id": "formal-content",
        "html": require('./formal-content/html').default,
        "css": require('./formal-content/css').default,
        "cssTablet": require('./formal-content/cssTablet').default,
        "cssMobile": require('./formal-content/cssMobile').default,
        "scss": require('./formal-content/scss').default,
        "scssTablet": require('./formal-content/scssTablet').default,
        "scssMobile": require('./formal-content/scssMobile').default
    }
]